var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-floor"},[(_vm.floorInfoList.length)?_vm._t("default",null,{"floorInfoList":_vm.floorInfoList,"floorNickNameList":_vm.floorNickNameList}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }